import React, { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout, useRowSelect } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import SortIcon from 'mdi-react/SortIcon';
import SortAscendingIcon from 'mdi-react/SortAscendingIcon';
import SortDescendingIcon from 'mdi-react/SortDescendingIcon';
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import { reducer, useEffectToDispatch, fetchApiData, initialState, TableFilter } from "@/shared/apiTableHelper"
import { useDispatch, sendFlashMessage } from "@/shared/components/flash"
//import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import ChangeStatusModal from "./ChangeStatusModal"
import FilterForm from "./FilterForm";
import SelectProgram from "@/containers/Manager/components/SelectProgram";
import axios from "axios";
import {
    Container,
    Card,
    CardBody,
    Row,
    Col, 
    Button
} from "reactstrap";

import { getManagerColumns, isRowOutsideCurrentProgram } from "./columns";
import AddProgramUserModal from './AddProgramUserModal'
import EditProgramUserModal from './EditProgramUserModal'
import ViewProgramUserModal from './ViewProgramUserModal'
//import { StatusFilter } from "../../components/StatusFilter";
//import { fetchRoles } from "../../../../shared/apiHelper";
//import ProgramBreadcrumb from '@/shared/components/ProgramBreadcrumb'
//import useHistory
//import { useHistory } from "react-router-dom";
//import { IndeterminateCheckbox } from "@/shared/components/form/IndeterminateCheckbox";
import ResendInviteModal from "./ResendInviteModal";
import {setProgramAction} from '@/redux/actions/programActions';
import store from '@/containers/App/store';
//import AlertPopup from "../../../../shared/components/modal/alertModal/AlertPopup";
// import ConfirmPopup from "../../../../shared/components/modal/confirmModal/ConfirmPopup";
import MoveUserModal from "./MoveUserModal";

const queryClient = new QueryClient()

const DataTable = ({ program, organization, embedded = false }) => {
    const { programId } = useParams();
    const [roles, setRoles] = useState([]);
    const [filter, setFilter] = useState({ keyword: '', role_id: '', search_in_all: false });
    const [useFilter, setUseFilter] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const flashDispatcher = useDispatch()
    const [trigger, setTrigger] = useState(Math.floor(Date.now() / 1000));
    const [loading, setLoading] = useState(false)
    const [isOpenAdd, setOpenAdd] = useState(false)
    const [isOpenEdit, setOpenEdit] = useState(false)
    const [isOpenView, setOpenView] = useState(false)
    const [selectedUser, selectUser] = useState(false)
    const [user, setUser] = useState(null)
    const [isChangeStatusOpen, setChangeStatusOpen] = useState(false)
    const [filteredData, setFilteredData] = useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [isResendInviteOpen, setResendInviteOpen] = useState(false)
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [isOpenConfirm, setIsOpenConfirm] = useState(false)
    const [isMoveUserOpen, setMoveUserOpen] = useState(false)
    //const history = useHistory();

    //const UserMenuLinks = () => {
    //    return (<><span className="btn btn-sm btn-primary" >Invite</span></>);
    //}

     const toggleMoveUser = () => {
       setMoveUserOpen((prevState) => !prevState);
     };
     const onClickMoveUser = (user) => {
       setUser(user);
       toggleMoveUser();
     };

    const toggleAdd = () => {
        setOpenAdd(prevState => !prevState)
    }
    const toggleView = () => {
        setOpenView(prevState => !prevState)
    }
    const toggleEdit = () => {
        setOpenEdit(prevState => !prevState)
    }
    const toggleChangeStatus = () => {
        setChangeStatusOpen(prevState => !prevState)
    }
    const onClickViewUser = (user_id) => {
        selectUser(user_id);
        toggleView();
    }
    const onClickEditUser = (user_id) => {
        toggleEdit();
        selectUser(user_id);
    }
    const toggleResendInvite = () => {
        setResendInviteOpen(prevState => !prevState)
    }
    const onClickResendInvite = (user) => {
        setSelectedRows(user);
        toggleResendInvite();
    }
    const alertToggle = () => {
        setIsAlertOpen(prevState => !prevState)
    }
    const toggleConfirm = (user) => {
        setUser(user)
        setIsOpenConfirm(prevState => !prevState)
    }
    const onClickRemoveUser = (user_id) => {
        if (!window.confirm('Are you sure to remove this user from this program?')) {
            return;
        }
        axios.delete(`/organization/${program.organization_id}/user/${user_id}/program/${program.id}`)
            .then((res) => {
                if (res.status === 200) {
                    flashDispatcher(sendFlashMessage('User removed successfully!', 'alert-success'))
                    setTrigger(Math.floor(Date.now() / 1000))
                }
            })
            .catch(error => {
               // flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
                console.log(error.response.data);
            })
    }

    const ActionLink = ({ disabled, onClick, children }) => disabled ? (
        <span
            className="link a"
            style={{ color: '#aaa', cursor: 'not-allowed' }}
            title="This manager is not assigned to the currently selected program"
        >
            {children}
        </span>
    ) : (
        <span onClick={onClick} className="link a">{children}</span>
    )

    const RenderActions = ({ row }) => {
        const isUserRoleAllowed = roles.some(userRole =>
            row.original.roles.some(opt => opt.value === userRole.id)
        );
        const isOutsideCurrentProgram = isRowOutsideCurrentProgram(row.original.programs, program.id, filter.search_in_all);
        return (
            <>
                <span onClick={() => onClickViewUser(row.original.id)} className="link a" >View</span>{' | '}
                <ActionLink disabled={isOutsideCurrentProgram} onClick={() => onClickEditUser(row.original.id)}>Edit</ActionLink>{' | '}
                <ActionLink disabled={isOutsideCurrentProgram} onClick={() => onClickRemoveUser(row.original.id)}>Unassign</ActionLink>{' | '}
                {isUserRoleAllowed && row.original.status.status === 'Pending Activation' && (
                    <span onClick={() => onClickResendInvite([row.original])} className="link a" >Resend Invite
                    </span>)
                }
                <ActionLink disabled={isOutsideCurrentProgram} onClick={() => onClickMoveUser(row.original)}>Move</ActionLink>
            </>
        )
    }

    const onClickStatus = user => {
        setUser(user);
        console.log('user', user);
        toggleChangeStatus()
    }
    const defaultContact = (user) => {
        axios.put(`/organization/${program.organization_id}/program/${program.id}/user/${user.id}/default-contact`)
            .then((res) => {
                if (res.status === 200) {
                    toggleConfirm();
                    flashDispatcher(sendFlashMessage('User has been set as default contact in the program!', 'alert-success'))
                    setTrigger(Math.floor(Date.now() / 1000))
                    program.default_contact_id = user.id
                    store.dispatch(setProgramAction(program))
                }
            })
            .catch(error => {
                // flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
                console.log(error.response.data);
            })
    }
    const onClickDefaultContact = (user, isDefaultContact) => {
        if (isDefaultContact) {
            alertToggle();
            return;
        }
        toggleConfirm(user);
    }

    const strShowUserStatus = user => {
        return user?.status?.status ? <span onClick={() => onClickStatus(user)} className={'link'}>{user.status.status}</span> : 'unknown'
    }

    let user_columns = [
        ...getManagerColumns({ searchInAll: filter.search_in_all }),
        ...[{
            Header: "",
            accessor: "action",
            Cell: ({ row }) => <RenderActions row={row} />,
            width: 200,
        }],
    ]
    user_columns.forEach((column, i) => {
        if (column.Header === 'Status') {
            user_columns[i].Cell = ({ row, value }) => { return strShowUserStatus(row.original) }
        }
        if (column.Header === 'Default Contact') {
            user_columns[i].Cell = ({ row }) => (
                <span onClick={() => onClickDefaultContact(row.original, program.default_contact_id === row.original.id)} className={'link'}>
                    {program.default_contact_id === row.original.id ? "Yes" : "No"}
                </span>
            )
        }
    })
    let columns = useMemo(() => user_columns, [roles, filter.search_in_all])
    const defaultColumn = React.useMemo(
        () => ({
            minWidth: 30
        }),
        []
    )

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] = React.useReducer(reducer, { ...initialState, queryPageSize: 10000 });
  
    const apiUrl = `/organization/${program?.organization_id}/program/${program?.id}/user`;

    useEffect(() => {
        const newFilter = { ...filter, role_id: selectedRoleId };
        setFilter(newFilter);
    }, [selectedRoleId]);

    const { isLoading, error, data, isSuccess } = useQuery(
        ['users', queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger, selectedRoleId],
        () => fetchApiData(
            {
                url: apiUrl,
                page: queryPageIndex,
                size: queryPageSize,
                filter,
                sortby: queryPageSortBy,
                trigger: queryTrigger
            }),
        {
            keepPreviousData: true,
            staleTime: Infinity,
            onSuccess: () => {
                console.log('Data fetching success, data:', data);
            }
        }
    );

    useEffect(() => {
        if (program) {
            getRoles();
        }
    }, [program]);

    const getRoles = () => {
        setLoading(true);
        /*fetchRoles(organization.id, true)
            .then(data => {
                const formattedRoles = data.map(role => ({
                    value: role.id,
                    label: role.name
                }));
                setRoles(formattedRoles);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching roles:", error);
                setLoading(false);
            });*/
    };

    const totalPageCount = Math.ceil(totalCount / queryPageSize)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        selectedFlatRows,
        state: { pageIndex, pageSize, sortBy },
    } = useTable({
        columns,
        data: useMemo(() => {
            if (!data?.results) return [];
            return data.results.filter(user =>
                user.roles?.some(role => role.name?.toLowerCase().includes('manager'))
            );
        }, [data]),
        initialState: {
            pageIndex: queryPageIndex,
            pageSize: queryPageSize,
            sortBy: queryPageSortBy,
        },
        manualPagination: true,
        pageCount: data ? totalPageCount : 0,
        autoResetSortBy: false,
        autoResetExpanded: false,
        autoResetPage: false,
        defaultColumn,

    },
        useSortBy,
        useExpanded,
        usePagination,
        useResizeColumns,
        useFlexLayout,
        useRowSelect
    );
    const allSelcetedRows = selectedFlatRows.map((row) => row.original);

    const manualPageSize = []

    useEffectToDispatch(dispatch, { pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger });

    useEffect(() => {
        if (organization?.id) {
            getRoles();
        }
    }, [organization?.id]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setUseFilter(true);
    };

    const handleRoleChange = (newRoleId) => {
        const newFilter = { ...filter, role_id: newRoleId };
        setFilter(newFilter);
        setUseFilter(true); //Trigger re-fetch or re-render as necessary
    };

    if (error) {
        return <p>Error: {JSON.stringify(error)}</p>;
    }

    if (isLoading) {
        return <p>Loading...</p>;
    }

    if (isSuccess)
        return (
            <>           
                {/*<AlertPopup isOpen={isAlertOpen} title="Verify default contact" message="User is a default contact already" toggle={alertToggle} />
                <ConfirmPopup isOpen={isOpenConfirm} toggle={toggleConfirm} action={() => defaultContact(user)}
                    message={`Are you sure to set this user as default contact in program!`} />*/}
            
                <div className={`table react-table${embedded ? ' manager-program-admin__embedded-table' : ''}`}>
                    <div className={`form form--horizontal pb-4${embedded ? ' manager-program-admin__embedded-toolbar' : ''}`}>
                        {!embedded && (
                            <Row>
                                <Col md="6">
                                    <SelectProgram />
                                </Col>
                                <Col md="6" style={{textAlign: 'right'}}>
                                    <a style={{ maxWidth: '200px' }}
                                        className="btn btn-primary account__btn account__btn--small"
                                        href="/manager/manage/program"
                                    >
                                        Back
                                    </a>
                                </Col>
                            </Row>
                        )}
                        <Row style={{width: '100%', alignItems: 'center'}} >
                            <Col md={embedded ? "8" : "9"} >
                                <FilterForm 
                                    onClickFilterCallback={handleFilterChange} 
                                    roles={roles}
                                    filter={filter}
                                    organization={organization}
                                />
                            </Col>
                            <Col md={embedded ? "4" : "3"} className={embedded ? "manager-program-admin__embedded-actions" : "pr-0"} style={!embedded ? {textAlign: 'right'} : undefined}>
                                <Button style={{ maxWidth: '200px' }}
                                    className="btn btn-primary account__btn account__btn--small"
                                    onClick={() => toggleAdd()} 
                                >
                                    Add User 
                                </Button>
                            </Col>
                        </Row>   
                    </div>
                    {user && (
                        <MoveUserModal
                            program={program}
                            user={user}
                            isOpen={isMoveUserOpen}
                            toggle={toggleMoveUser}
                            setTrigger={setTrigger}
                        />
                    )}
                    <AddProgramUserModal 
                        organization={organization} 
                        program={program} 
                        isOpen={isOpenAdd} 
                        setOpen={setOpenAdd} 
                        toggle={toggleAdd} 
                        setTrigger={setTrigger} />
                    {selectedUser && isOpenView && (
                        <ViewProgramUserModal
                            organization={organization}
                            program={program}
                            userid={selectedUser}
                            isOpen={isOpenView}
                            toggle={toggleView}
                        />
                    )}
                    {/*
                     <div className="pb-4 ">
                        <UserMenuLinks />
                    </div>*/}
                    
                    <EditProgramUserModal organization={organization} program={program}
                     userid={selectedUser} isOpen={isOpenEdit} setOpen={setOpenEdit} toggle={toggleEdit}
                      setTrigger={setTrigger} />
                    {user && <ChangeStatusModal 
                        isOpen={isChangeStatusOpen} 
                        setOpen={setChangeStatusOpen}
                        toggle={toggleChangeStatus} 
                        setTrigger={setTrigger} 
                        user={user} 
                        />}
                    {!!selectedRows.length && <ResendInviteModal isOpen={isResendInviteOpen} setOpen={setResendInviteOpen} toggle={toggleResendInvite} {...{ selectedRows, program, setTrigger }} />}
                    <div className="manager-program-admin__table-shell">
                        <table {...getTableProps()} className="table table--stack-mobile">
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map(column => (
                                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                {column.render('Header')}
                                                {column.isSorted ? <Sorting column={column} /> : ''}
                                                <div
                                                    {...column.getResizerProps()}
                                                    className={`resizer ${column.isResizing ? 'isResizing' : ''
                                                        }`}
                                                />
                                            </th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {page.map(row => {
                                    prepareRow(row);
                                    const subCount = (row.id.match(/\./g) || []).length
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {
                                                row.cells.map(cell => {
                                                    const paddingLeft = subCount * 20
                                                    return <td
                                                    {...cell.getCellProps()}
                                                    data-label={typeof cell.column.Header === 'string' ? cell.column.Header : ''}
                                                    ><span style={cell.column.Header === '#' ? { paddingLeft: `${paddingLeft}px` } : null}>{cell.render('Cell')}</span></td>
                                                })
                                            }
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </table>
                    </div>
                </div>
            </>
        )
}

const Sorting = ({ column }) => (
    <span className="react-table__column-header sortable">
        {column.isSortedDesc === undefined ? (
            <SortIcon />
        ) : (
            <span>
                {column.isSortedDesc
                    ? <SortAscendingIcon />
                    : <SortDescendingIcon />}
            </span>
        )}
    </span>
);

const TableWrapper = ({ program, organization, embedded = false }) => {
    return (
        <QueryClientProvider client={queryClient}>
            {program && (<DataTable program={program} organization={organization} embedded={embedded} />)}
        </QueryClientProvider>
    )
}

const ProgramUsers = ({  program, organization, embedded = false }) => {
    const [programData, setProgram] = useState(null);
    const fetchProgramData = async (program) => {
        try {
            const response = await axios.get(`/organization/${program.organization_id}/program/${program.id}`);
            setProgram(response.data)
        } catch (e) {
            throw new Error(`API error:${e?.message}`);
        }
    };
    useEffect(() => {
        if (program) {
            fetchProgramData(program)
        }
    }, [program])

    if (!program?.id) {
        return 'Loading...'
    }

    if (embedded) {
        return (
            <div className="manager-program-admin__embedded-view">
                {program && organization && <TableWrapper program={programData} organization={organization} embedded={true} />}
            </div>
        );
    }

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Program Users</h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            {program && organization && <TableWrapper program={programData} organization={organization} />}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}


const mapStateToProps = (state) => {
  return {
    organization: state.organization,
    program: state.program
  };
};

export default connect(mapStateToProps)(ProgramUsers);
